import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, desc, action }: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6 md:mb-8">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-accent-600 mb-2">
            <span className="w-4 h-0.5 bg-accent-500"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950">{title}</h2>
        {desc && <p className="text-sm text-foreground-500 mt-2 max-w-2xl leading-relaxed">{desc}</p>}
      </div>
      {action}
    </div>
  );
}